
<app-header [logoImg]="logoImg" [classHeader]="classHeader" [loginButton]="loginButton"></app-header>
<app-revolution-slider></app-revolution-slider>
<div class="main-content">
    <app-our-partners *ngIf="fullModeService.fullMode==false"></app-our-partners>
    <app-features *ngIf="fullModeService.fullMode==false"></app-features>
    <app-our-services [List]="List" [titleSectionProp]="titleSectionProp" *ngIf="fullModeService.fullMode"></app-our-services>
    <app-working-language></app-working-language>
    <app-about-us></app-about-us>
</div>
<app-footer></app-footer>
